import { render, staticRenderFns } from "./FocusTrap.vue?vue&type=template&id=f5a88222&scoped=true&"
import script from "./FocusTrap.vue?vue&type=script&lang=js&"
export * from "./FocusTrap.vue?vue&type=script&lang=js&"
import style0 from "./FocusTrap.vue?vue&type=style&index=0&id=f5a88222&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a88222",
  null
  
)

export default component.exports